import { render, staticRenderFns } from "./InstitutionQuotas.vue?vue&type=template&id=016c108e&scoped=true"
import script from "./InstitutionQuotas.vue?vue&type=script&lang=js"
export * from "./InstitutionQuotas.vue?vue&type=script&lang=js"
import style0 from "./InstitutionQuotas.vue?vue&type=style&index=0&id=016c108e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c108e",
  null
  
)

export default component.exports